
    import { useContext, useState }  from 'react'
    import GlobalContext from 'proj/contexts/global';
    import ClassNames from 'classnames';

    import * as Select from './components';

    export default ( { ...props } ) =>
    {
        const { active, data, setActive, setStore, tracker } = useContext(GlobalContext);
        const { title, subhed, options, submit, module, instruction, ...select } = data?.sections[active] || {};
        const [selected, setSelected] = useState([]);

        // --------------------
        //  Events
        // --------------------

        const onOptionClicked = e => 
        {
            const id = parseInt(e.currentTarget.dataset['id']);
            const indexOfEntry = selected.indexOf(id);
            
            if(module?.select_max)
            {
                if(indexOfEntry == -1)
                {
                    if(selected.length < module?.select_max) setSelected( [...selected, id] );
                }
                else
                {
                    setSelected( [...selected.slice(0, indexOfEntry), ...selected.slice(indexOfEntry + 1, selected.length)] );
                }
            }
            else
            {
                setSelected([id]);
            }
        }

        const onSubmitClicked = e =>
        {
            if(module?.store)
            {
                const selections = selected.map(val => options[val]);
                setStore({ [module.store]: selections });
            }

            if(module?.track)
            {
                const selection = options[selected[0]];
                const trackId = module.track.replace("{value}", selection?.value);
                tracker.trackMetric(trackId);
            }

            setActive(active + 1);
        }

        // --------------------
        //  Build
        // --------------------

        const getOption = (val, id) =>
            <Select.Option key={ `section-${active}-option-${id}` } 
                className={ ClassNames(val.class, { active: selected.indexOf(id) != -1 }) } 
                onClick={ onOptionClicked }
                data-id={ id }>
                    <Select.OptionLabel text={ val.label } />
            </Select.Option>

        return  <Select.Content className={ ClassNames(module?.class) }>
                    { title && <Select.Title text={ title } /> }
                    { subhed && <Select.Subhed text={ subhed } /> }
                    <Select.OptionContainer className={ ClassNames( { disabled: module?.select_max && selected.length == module?.select_max } ) }>
                        { options.map(getOption) }
                    </Select.OptionContainer>
                    { instruction && <Select.Instruction text={ instruction } />}
                    { submit && <Select.Submit className={ ClassNames({enabled: selected.length > 0}) } text={ submit } onClick={ onSubmitClicked } /> }
                </Select.Content>
    }